import { api } from '@/service/http';

export const getCustomerVersCard = async id => {
    try {
        const {result, rows} = await api('counteragent./customer-vers/card/get', {id});
         if (!result) {
          return {
            result: false,
            error: 'database result: false',
            uuid: '83ba194f-494d-4b01-99bc-61977527cb30',
          }
        }
        return {
          result: true,
          data: rows
        }
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: 'f70731da-1e54-4ab1-9c7c-51e54bdc14cf',
        }
    }
};

export const saveCustomerVersCard = async () => {
    // todo сделать реализацию сохранения версионной карточки контрагента
};